import PlanDetailsContainer from 'modules/modals/PlanDetails/containers/PlanDetailsContainer';
import { useModal } from 'components/shared/modal';
import { useTranslation } from 'react-i18next';
import SharedSelectPlan from 'modules/modals/SelectPlan/containers/SharedSelectPlan';
import useSelectPlan from 'modules/modals/SelectPlan/hooks/useSelectPlan';
import { OneChipInfoProvider } from 'contexts/OneChipInfoContext';

const SelectPlan = ({ onComplete = () => {} }) => {
  const modal = useModal({ stacked: false });

  const { t } = useTranslation();

  const preselect = (infoData) => {
    return {};
  };

  const readOnly = (infoData) => {
    return {
      sku: Boolean(infoData.esim.storeUnitUuid),
    };
  };

  const handleOpenPlanDetailsModal = (data) => {
    modal.openModal(
      PlanDetailsContainer,
      {
        data: {
          ...data,
        },
        onComplete,
      },
      {
        fullWidth: true,
        maxWidth: 'md',
        title: [
          { name: 'PlanSelectionModal', title: t('views.network_apps.select_apps.network_apps') },
          { name: '', title: data.planName },
        ],
        close: true,
        sx: {
          '& .ModalContentWrapper-root': {
            backgroundColor: '#F5F5F5',
          },
        },
      }
    );
  };

  return (
    <SharedSelectPlan
      readOnly={readOnly}
      preselect={preselect}
      onPlanOpen={handleOpenPlanDetailsModal}
      usePlanList={useSelectPlan}
    />
  );
};

const withOnechipInfoProvider = (Component) => {
  return (props) => (
    <OneChipInfoProvider>
      <Component {...props} />
    </OneChipInfoProvider>
  );
};

export default withOnechipInfoProvider(SelectPlan);
